import { Enum } from "@/commons/enums/Type";

export class AuthorityEnum {
  static FLUX_MASTER = { value: 1, text: "FLUX ADMIN" };
  static FLUX_MEMBER = { value: 2, text: "FLUX MEMBER" };
  static AGENCY_MASTER = { value: 3, text: "AGENCY ADMIN" };
  static AGENCY_MEMBER = { value: 4, text: "AGENCY MEMBER" };
  static CLIENT_MASTER = { value: 5, text: "CLIENT ADMIN" };
  static CLIENT_MEMBER = { value: 6, text: "CLIENT MEMBER" };

  static getByValue(value: number): Enum | undefined {
    if (value === AuthorityEnum.FLUX_MASTER.value) {
      return AuthorityEnum.FLUX_MASTER;
    }
    if (value === AuthorityEnum.FLUX_MEMBER.value) {
      return AuthorityEnum.FLUX_MEMBER;
    }
    if (value === AuthorityEnum.AGENCY_MASTER.value) {
      return AuthorityEnum.AGENCY_MASTER;
    }
    if (value === AuthorityEnum.AGENCY_MEMBER.value) {
      return AuthorityEnum.AGENCY_MEMBER;
    }
    if (value === AuthorityEnum.CLIENT_MASTER.value) {
      return AuthorityEnum.CLIENT_MASTER;
    }
    if (value === AuthorityEnum.CLIENT_MEMBER.value) {
      return AuthorityEnum.CLIENT_MEMBER;
    }
    return undefined;
  }

  // パラメータで受け取ったユーザータイプがマスターかどうかのチェック
  static checkMasterByValue(value: number | null | undefined): boolean {
    if (value === null || value === undefined) {
      return false;
    }

    if (
      value === AuthorityEnum.FLUX_MASTER.value ||
      value === AuthorityEnum.AGENCY_MASTER.value ||
      value === AuthorityEnum.CLIENT_MASTER.value
    ) {
      return true;
    }
    return false;
  }

  // パラメータで受け取ったユーザータイプがFLUXかどうかのチェック
  static checkFluxByValue(value: number | null | undefined): boolean {
    if (value === null || value === undefined) {
      return false;
    }

    if (value === AuthorityEnum.FLUX_MASTER.value || value === AuthorityEnum.FLUX_MEMBER.value) {
      return true;
    }
    return false;
  }

  // パラメータで受け取ったユーザータイプがAgencyかどうかのチェック
  static checkAgencyByValue(value: number | null | undefined): boolean {
    if (value === null || value === undefined) {
      return false;
    }

    if (
      value === AuthorityEnum.AGENCY_MASTER.value ||
      value === AuthorityEnum.AGENCY_MEMBER.value
    ) {
      return true;
    }
    return false;
  }

  // パラメータで受け取ったユーザータイプがClientかどうかのチェック
  static checkClientByValue(value: number | null | undefined): boolean {
    if (value === null || value === undefined) {
      return false;
    }

    if (
      value === AuthorityEnum.CLIENT_MASTER.value ||
      value === AuthorityEnum.CLIENT_MEMBER.value
    ) {
      return true;
    }
    return false;
  }
}
